'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { useComponentDefaultProps } from '@s7/styles';
import { BaseTypography } from './BaseTypography.js';
import { createPolymorphicComponent } from '../utils/PolymorphicComponent/PolymorphicComponent.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * Фабрика для создания компонентов типографики.
 * Полезно при реализации встроенной типографики, например, используется в компоненте Button.
 * */ function createTypography(options) {
    var componentId = options.componentId, displayName = options.displayName, defaultProps = options.defaultProps;
    var _Impl = /*#__PURE__*/ forwardRef(function(props, ref) {
        var others = useComponentDefaultProps(componentId, defaultProps, props);
        return /*#__PURE__*/ jsx(BaseTypography, _extends({
            ref: ref,
            __staticSelector: componentId
        }, others));
    });
    var Impl = createPolymorphicComponent(_Impl);
    Impl.displayName = displayName || componentId;
    return Impl;
}

export { createTypography };
